import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { ShortStayRuleDetails } from '../../../common/types/rates.types';
import ShortStayForm from './ShortStayForm';
import {
  deleteSeasonRateRuleAsync,
  getSeasonRateShortStayRuleAsync,
  selectShortStayRuleDetails,
  selectShortStayRuleDetailsLoadingStatus,
  updateSeasonRateShortStayRuleAsync,
} from '../seasonRateRulesSlice';

function SeasonRateShortStay({
  seasonRateId,
  hasWriteAccess,
}: {
  seasonRateId: string;
  hasWriteAccess: boolean;
}) {
  const dispatch = useAppDispatch();
  const shortStayRuleDetails = useAppSelector(selectShortStayRuleDetails);
  const shortStayStatus = useAppSelector(
    selectShortStayRuleDetailsLoadingStatus,
  );

  const initialData: ShortStayRuleDetails = {
    seasonRateId,
    durationRestriction: null,
    priceChange: {
      priceChangeType: 0,
      percent: 0,
      difference: 0,
    },
    isActive: true,
    isCopyable: true,
  };

  const [data, setData] = useState(initialData);
  const [submitted, setSubmitted] = useState(false);
  const [deleted, setDeleted] = useState(false);

  useEffect(() => {
    dispatch(getSeasonRateShortStayRuleAsync(seasonRateId));
  }, [seasonRateId, dispatch]);

  useEffect(() => {
    if (shortStayRuleDetails && shortStayRuleDetails.id) {
      setData(shortStayRuleDetails);
    } else {
      setData(initialData);
    }
  }, [shortStayRuleDetails]);

  const handleInputChange = event => {
    const path = event.target.name.split('.');
    const finalProp = path.pop();
    const newData = { ...data };
    let pointer = newData;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    setData(newData);
  };

  const handleSelectChange = (selectedOption, name) => {
    const path = name.split('.');
    const finalProp = path.pop();
    const newData = { ...data };
    let pointer = newData;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] = selectedOption.value;
    setData(newData);
  };

  const onSubmit = () => {
    dispatch(updateSeasonRateShortStayRuleAsync(data));
    setSubmitted(true);
  };

  const onDelete = () => {
    if (window.confirm('Haluatko varmasti poistaa säännön?')) {
      dispatch(deleteSeasonRateRuleAsync(data.id));
      setSubmitted(false);
      setData(initialData);
      setDeleted(true);
    }
  };

  return (
    <ShortStayForm
      loadingStatus={shortStayStatus}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      submitted={submitted}
      deleted={deleted}
      data={data}
      hasWriteAccess={hasWriteAccess}
    />
  );
}

export default SeasonRateShortStay;
